import { toast } from 'react-toastify'
import { useMutation } from 'urql'

import { SurveyForm, TSurveyResponse } from '@/components/survey-form'
import { graphql } from '@/gql/generated'
import { Modal, ModalProps } from './Modal'

interface Props extends ModalProps {
  challengeId: string
  onOk: () => void
}

export type SchoolGroupData = {
  name: string
}

export const ChallengeContestSourceSurveyModal = ({
  isOpen,
  challengeId,
  onOk,
  ...rest
}: Props): JSX.Element => {
  const [, createSurveyResponse] = useMutation(
    ChallengeContestSourceSurveyModal_CreateSurveyResponseMutation
  )
  const onSubmitSurvey = async ({
    surveyId,
    responses,
  }: {
    surveyId: string
    responses: TSurveyResponse[]
  }) => {
    try {
      if (surveyId && responses.length > 0) {
        const result = await createSurveyResponse({
          input: {
            surveyId,
            responseableInput: { challengeId },
            surveyResponseAnswers: responses,
          },
        })

        if (result.error || result.data?.surveyResponseCreate?.errors) {
          return toast.error('アンケートの回答に失敗しました', {
            toastId: 'create-survey-response-failed',
            position: 'bottom-right',
          })
        }

        toast.success('アンケートに回答しました', {
          toastId: 'create-survey-response-success',
          position: 'bottom-right',
        })
        onOk()
      }
    } catch (error) {
      return toast.error('アンケートの回答に失敗しました', {
        toastId: 'create-survey-response-failed',
        position: 'bottom-right',
      })
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      showCloseButton={false}
      customStyles={{
        content: {
          textAlign: 'center',
          backgroundColor: '#F5F7FC',
          boxShadow: '0px 2px 2px 0px #00000040',
          padding: '48px 69px',
          width: '600px',
        },
      }}
      {...rest}
    >
      <SurveyForm
        surveyName="contest_source"
        titleClassName="text-center"
        labelClassName="text-center"
        onSubmit={onSubmitSurvey}
      />
    </Modal>
  )
}

const ChallengeContestSourceSurveyModal_CreateSurveyResponseMutation = graphql(`
  mutation ChallengeContestSourceSurveyModal_CreateSurveyResponseMutation(
    $input: SurveyResponseCreateInput!
  ) {
    surveyResponseCreate(input: $input) {
      errors {
        ... on ValidationError {
          field
          message
        }
      }
    }
  }
`)
